import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './ui/Button';
import { BarChart3, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  const navBackground = useTransform(scrollY, [0, 50], ['rgba(15, 23, 42, 0)', 'rgba(15, 23, 42, 0.9)']);
  const navBorder = useTransform(scrollY, [0, 50], ['rgba(30, 41, 59, 0)', 'rgba(30, 41, 59, 1)']);
  return <motion.nav style={{
    backgroundColor: navBackground,
    borderBottomColor: navBorder
  }} className="fixed top-0 left-0 right-0 z-50 border-b backdrop-blur-md transition-colors" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="flex items-center justify-between h-20" data-id="element-188">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-189">
            <div className="w-10 h-10 rounded-lg bg-emerald-500 flex items-center justify-center shadow-lg shadow-emerald-500/20" data-id="element-190">
              <BarChart3 className="text-white w-6 h-6" data-id="element-191" />
            </div>
            <span className="text-xl font-bold text-white tracking-tight" data-id="element-192">
              Butineurjeu
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-193">
            <a href="#features" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-194">
              Features
            </a>
            <a href="#showcase" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-195">
              Showcase
            </a>
            <a href="#pricing" className="text-sm font-medium text-slate-300 hover:text-white transition-colors" data-id="element-196">
              Pricing
            </a>
            <Button variant="ghost" size="sm" data-id="element-197">
              Log In
            </Button>
            <Button size="sm" data-id="element-198">Start Free Trial</Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden" data-id="element-199">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-slate-300 hover:text-white p-2" data-id="element-200">
              {isMobileMenuOpen ? <X data-id="element-201" /> : <Menu data-id="element-202" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden bg-slate-900 border-b border-slate-800 p-4 space-y-4" data-id="element-203">
          <a href="#features" className="block text-slate-300 hover:text-white py-2" data-id="element-204">
            Features
          </a>
          <a href="#showcase" className="block text-slate-300 hover:text-white py-2" data-id="element-205">
            Showcase
          </a>
          <a href="#pricing" className="block text-slate-300 hover:text-white py-2" data-id="element-206">
            Pricing
          </a>
          <div className="pt-4 flex flex-col gap-3" data-id="element-207">
            <Button variant="outline" className="w-full" data-id="element-208">
              Log In
            </Button>
            <Button className="w-full" data-id="element-209">Start Free Trial</Button>
          </div>
        </motion.div>}
    </motion.nav>;
}